<template>
  <b-modal
    id="reasonPopupMe"
    ref="innerModal"
    :lazy="false"
    centered
    title="Button Action"
    ok-title="Save & Continue"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    cancel-title="Skip"
    @show="resetModal"
    @hidden="resetModal"
    @ok.prevent="validationButtonForm"
    @cancel="skipTheReason"
  >
    <b-overlay
      id="overlay-background"
      :show="btnloader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <validation-observer ref="buttonRules">
        <b-form>
          <b-alert
            v-if="buttonError"
            variant="warning"
            show
          >
            <div class="alert-body">
              {{ buttonError }}
            </div>
          </b-alert>
          <p v-if="reason">
            <strong>You choose {{ reason.button_title }}</strong>
          </p>
          <b-row>
            <b-col
              sm="12"
            >
              <b-form-group
                :label="reason.reason_description"
                label-for="description"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Description"
                  rules="required"
                >
                  <b-form-textarea
                    id="textarea-rows"
                    v-model="description"
                    :placeholder="$t('DEBTIA_DESCRIPTION')"
                    rows="4"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BOverlay, BModal, BForm, BFormGroup, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { EventBus } from '@/event-bus'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BOverlay,
    BModal,
    BFormGroup,
    BForm,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    userActionButtonClicked: {
      type: Function,
      required: true,
    },
    reason: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    processId: {
      type: [Number, String],
      required: true,
    },
    btnType: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      description: '',
      btnloader: false,
      buttonError: '',
    }
  },
  methods: {
    open() {
      this.$refs.innerModal.show()
    },
    resetModal() {
      this.description = ''
      this.btnloader = false
      this.buttonError = ''
    },
    validationButtonForm() {
      this.$refs.buttonRules.validate().then(success => {
        if (success) {
          this.btnloader = false
          this.$refs.innerModal.hide()
          this.userActionButtonClicked(this.reason.id, this.processId, 1, this.description, this.btnType)
          // EventBus.$emit('refreshLogs')
        }
      })
    },
    skipTheReason() {
      this.$refs.innerModal.hide()
      this.userActionButtonClicked(this.reason.id, this.processId, 1, 'Reason Skipped by Partner', this.btnType)
    },
  },
}
</script>
